<template>
  <el-container class="main-layout-wrapper" style="height: 100vh;">
    <!-- 侧边栏 -->
    <el-aside class="sidebar" :class="{ collapsed: isCollapsed }" :width="isCollapsed ? '64px' : '220px'">
      <!-- Logo 和公司名区域 -->
      <div class="sidebar-logo">
        <div class="sidebar-logo-inner">
          <img src="../assets/logo.png" alt="Logo" class="sidebar-logo-img">
          <div class="sidebar-logo-text" :class="{ collapsed: isCollapsed }">鸭鸭海岛日记APP分销后台</div>
        </div>
      </div>

      <el-menu ref="sidebarMenu" :default-active="activeMenu" class="sidebar-menu" background-color="transparent"
        :text-color="menuTextColor" :active-text-color="menuActiveTextColor" router style="border: none;">
        <!-- 数据大屏 - 仅超级管理员可见 -->
        <el-menu-item v-if="isSuperAdmin" index="/data-dashboard">
          <i class="el-icon-data-line"></i>
          <span slot="title">数据大屏</span>
        </el-menu-item>

        <!-- 广告收入 - 所有人都能看 -->
        <el-menu-item index="/ad-revenue">
          <i class="el-icon-data-analysis"></i>
          <span slot="title">广告收入</span>
        </el-menu-item>

        <!-- 管理员管理 - 仅开发者可见 -->
        <!-- <el-menu-item v-if="isSuperAdmin && isDeveloper" index="/admin-management">
          <i class="el-icon-user"></i>
          <span slot="title">管理员管理</span>
        </el-menu-item> -->

      

        <!-- 用户管理 - 所有人都能看，但操作受限 -->
        <el-menu-item index="/user-management">
          <i class="el-icon-user-solid"></i>
          <span slot="title">用户管理</span>
        </el-menu-item>

        <!-- 团长收益 - 仅团长可见 -->
        <el-menu-item v-if="isAgent" index="/agent-daily-revenue">
          <i class="el-icon-s-cooperation"></i>
          <span slot="title">团长收益</span>
        </el-menu-item>

        <!-- 用户提现 - 所有人都能看，但操作受限 -->
        <el-menu-item index="/user-withdrawal">
          <i class="el-icon-money"></i>
          <span slot="title">用户提现</span>
        </el-menu-item>

           <!-- 金币明细 - 仅超级管理员可见 -->
        <el-menu-item v-if="isSuperAdmin" index="/coin-flow">
          <i class="el-icon-coin"></i>
          <span slot="title">金币明细</span>
        </el-menu-item>

        <el-menu-item v-if="isSuperAdmin" index="/ad-pool-settlement">
          <i class="el-icon-collection"></i>
          <span slot="title">副广池结算</span>
        </el-menu-item>

             <!-- 系统管理 - 仅超级管理员可见 -->
        <el-submenu v-if="isSuperAdmin" index="system-management">
          <template slot="title">
            <i class="el-icon-setting"></i>
            <span>app管理</span>
          </template>
          <el-menu-item index="/system/config">
            <i class="el-icon-s-tools"></i>
            <span slot="title">系统配置</span>
          </el-menu-item>
          <el-menu-item index="/system/app">
            <i class="el-icon-mobile-phone"></i>
            <span slot="title">信息管理</span>
          </el-menu-item>
      
        </el-submenu>

           <!-- 风控管理 - 仅超级管理员可见 -->
        <el-menu-item v-if="isSuperAdmin" index="/risk-management">
          <i class="el-icon-warning-outline"></i>
          <span slot="title">风控管理</span>
        </el-menu-item>

     
      </el-menu>

      <!-- <div v-if="$route.path !== '/data-dashboard'" class="sidebar-icp" > -->
      <div v-if="false" class="sidebar-icp" >
        <!-- 冀ICP备2024066140号-2 -->
      </div>
    </el-aside>

    <!-- 右侧容器，包含头部和主体 -->
    <el-container>
      <!-- 顶部标签页 -->
      <el-header class="header">
        <div class="header-left">
          <button class="hamburger-btn" @click="toggleSidebar" :title="isCollapsed ? '展开菜单' : '折叠菜单'">
            <svg viewBox="0 0 20 20" width="20" height="20" fill="currentColor">
              <rect x="0" y="2" width="20" height="2" rx="1" />
              <polygon points="2,7 7,10 2,13" />
              <rect x="8" y="7" width="12" height="2" rx="1" />
              <rect x="8" y="11" width="12" height="2" rx="1" />
              <rect x="0" y="16" width="20" height="2" rx="1" />
            </svg>
          </button>
          <div class="header-title">
            <i class="el-icon-star-on header-title-icon"></i>
            <p>欢迎使用</p>
          </div>
        </div>

        <div class="header-right">
          <!-- 用户信息区域 -->
          <el-dropdown @command="handleUserCommand">
            <span class="user-dropdown-link">
              <i class="el-icon-user" style="margin-right: 5px;"></i>
              {{ username || '用户' }}
              <el-tag v-if="isSuperAdmin" size="mini" type="danger" style="margin-left: 8px;">超级管理员</el-tag>
              <el-tag v-else-if="isAgent" size="mini" type="warning" style="margin-left: 8px;">代理</el-tag>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="changePassword">修改密码</el-dropdown-item>
              <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <!-- 主体区域 -->
      <el-main class="main-content">
        <el-breadcrumb class="page-breadcrumb" separator="/">
          <el-breadcrumb-item :to="{ path: '/ad-revenue' }">
            <i class="el-icon-s-home"></i> 分销后台
          </el-breadcrumb-item>
          <el-breadcrumb-item v-if="currentPageName">
            {{ currentPageName }}
          </el-breadcrumb-item>
        </el-breadcrumb>

        <tags-view />

        <keep-alive :max="10">
          <router-view />
        </keep-alive>
      </el-main>
    </el-container>
    <!-- 修改密码对话框 -->
    <el-dialog title="修改密码" :visible.sync="showPasswordForm" width="450px" center append-to-body>
      <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" label-width="100px">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input v-model="passwordForm.oldPassword" type="password" placeholder="请输入原密码" show-password></el-input>
        </el-form-item>

        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="passwordForm.newPassword" type="password" placeholder="请输入新密码" show-password></el-input>
        </el-form-item>

        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="passwordForm.confirmPassword" type="password" placeholder="请再次输入新密码"
            show-password></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="showPasswordForm = false">取 消</el-button>
        <el-button type="primary" @click="submitPasswordForm">确 定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import { request, put } from '@/utils/http.js'
import TagsView from '@/components/TagsView.vue'

export default {
  name: 'MainLayout',
  components: { TagsView },
  data() {
    return {
      username: localStorage.getItem('username') || '',
      isCollapsed: localStorage.getItem('sidebarCollapsed') === 'true',
      showPasswordForm: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    }
  },
  computed: {
    activeMenu() {
      return this.$route.path
    },
    role() {
      return parseInt(localStorage.getItem('role')) || 0
    },
    showSystemConfig() {
      return this.isSuperAdmin
    },
    isSuperAdmin() {
      return this.role === 0
    },
    isAgent() {
      // 代理/团长 role = 1 或 2
      return this.role === 1 || this.role === 2
    },
    isDeveloper() {
      // 仅开发账号可见管理员管理、商城管理等敏感页面
      return this.username === 'qiling'
    },
    // 是否有修改权限（超级管理员）
    canEdit() {
      return this.role === 0
    },
    menuTextColor() {
      return '#cbd5e1'
    },
    menuActiveTextColor() {
      return '#06b6d4'
    },
    currentPageName() {
      const nameMap = {
        'AdRevenueQuery': '广告收入',
        'SystemConfigManagement': '系统配置',
        'AppInfoManagement': 'App信息管理',
        'UserManagement': '用户管理',
        'UserWithdrawalManagement': '用户提现',
        'AdminManagement': '管理员管理',
        'GoodsManagement': '自营商品管理',
        'ExternalMallManagement': '外链商品管理',
        'GoodsCategoryManagement': '分类管理',

        'ExchangeOrderManagement': '兑换订单管理',
        'RiskManagement': '风控管理',
        'AgentDailyRevenue': '团长收益'
      }
      return nameMap[this.$route.name] || ''
    },
    passwordRules() {
      const validateConfirmPassword = (rule, value, callback) => {
        if (value !== this.passwordForm.newPassword) {
          callback(new Error('两次输入的密码不一致'))
        } else {
          callback()
        }
      }

      return {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
          { min: 6, max: 32, message: '密码长度在6到32个字符', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 32, message: '密码长度在6到32个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    '$route.path': {
      immediate: true,
      handler(path) {
        this.$nextTick(() => {
          if (!this.$refs.sidebarMenu) return
          // 根据当前路径决定打开哪个子菜单，关闭另一个
          const openSub = path.startsWith('/mall/') ? 'mall-management'
            : path.startsWith('/system/') ? 'system-management'
            : null
          ;['mall-management', 'system-management'].forEach(sub => {
            if (sub === openSub) {
              this.$refs.sidebarMenu.open(sub)
            } else {
              this.$refs.sidebarMenu.close(sub)
            }
          })
        })
      }
    }
  },
  methods: {
    toggleSidebar() {
      this.isCollapsed = !this.isCollapsed
      localStorage.setItem('sidebarCollapsed', this.isCollapsed)
    },
    handleMenuSelect(key) {
      if (this.$route.path !== key) {
        this.$router.push(key).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err
          }
        })
      }
    },
    async handleUserCommand(command) {
      switch (command) {
        case 'logout':
          try {
            await request('/admin/AdminAccount/logout', { method: 'POST' })
          } catch (error) {
            console.warn('后端退出接口调用失败:', error)
          }
          localStorage.removeItem('token')
          localStorage.removeItem('role')
          localStorage.removeItem('status')
          localStorage.removeItem('username')
          this.$router.push('/login')
          this.$message.success('已安全退出登录')
          break
        case 'changePassword':
          this.openPasswordForm()
          break
      }
    },
    openPasswordForm() {
      this.passwordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
      this.showPasswordForm = true
      this.$nextTick(() => {
        if (this.$refs.passwordForm) {
          this.$refs.passwordForm.clearValidate()
        }
      })
    },
    submitPasswordForm() {
      this.$refs.passwordForm.validate(async (valid) => {
        if (!valid) return

        try {
          await put('/admin/change-password', {
            oldPassword: this.passwordForm.oldPassword,
            newPassword: this.passwordForm.newPassword
          })
          this.$message.success('密码修改成功，请重新登录')
          this.showPasswordForm = false
          // 清空登录态，跳转登录页
          localStorage.removeItem('token')
          localStorage.removeItem('role')
          localStorage.removeItem('status')
          localStorage.removeItem('username')
          localStorage.removeItem('userId')
          this.$router.push('/login')
        } catch (error) {
          this.$message.error(error.message || '密码修改失败')
        }
      })
    }
  }
}
</script>
<style scoped>
/* ========== Sidebar ========== */
.sidebar {
  position: relative;
  background: #304156;
  height: 100%;
  border-right: 1px solid #1d2b3a;
  transition: width 0.3s ease;
  overflow: hidden;
}

.sidebar-logo {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 20px;
  background: #2b3a4a;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  transition: all 0.3s ease;
  position: relative;
  z-index: 1;
}

.sidebar-logo-inner {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.sidebar-logo-img {
  max-height: 36px;
  margin-right: 10px;
  max-width: 100%;
  height: auto;
  vertical-align: middle;
  flex-shrink: 0;
}

.sidebar-logo-text {
  color: #e8eaed;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 1px;
  max-width: 170px;
  opacity: 1;
  margin-left: 0;
  overflow: visible;
  white-space: nowrap;
  flex-shrink: 0;
  transition: max-width 0.3s ease, opacity 0.3s ease, margin-left 0.3s ease;
}

.sidebar-logo-text.collapsed {
  max-width: 0;
  opacity: 0;
  margin-left: 0;
}

.sidebar-menu {
  transition: all 0.3s ease;
  position: relative;
  z-index: 1;
  margin-top: 4px;
}

/* ===== 菜单项通用 ===== */
.sidebar-menu ::v-deep .el-menu-item {
  transition: all 0.25s ease;
  margin: 2px 8px;
  border-radius: 4px;
  height: 46px;
  line-height: 46px;
  font-size: 14px;
  color: #bfcbd9 !important;
}

.sidebar-menu ::v-deep .el-menu-item:hover {
  background-color: rgba(255, 255, 255, 0.05) !important;
  color: #fff !important;
}

/* ===== 激活态 ===== */
.sidebar-menu ::v-deep .el-menu-item.is-active {
  background-color: #409EFF !important;
  color: #fff !important;
  font-weight: 600;
}

/* ===== 子菜单项 ===== */
.sidebar-menu ::v-deep .el-submenu .el-menu-item {
  background: transparent !important;
  padding-left: 50px !important;
  margin: 2px 8px 2px 16px;
  border-radius: 4px;
  height: 38px;
  line-height: 38px;
  font-size: 13px;
  color: #bfcbd9 !important;
}

.sidebar-menu ::v-deep .el-submenu .el-menu-item:hover {
  background-color: rgba(255, 255, 255, 0.05) !important;
  color: #fff !important;
}

.sidebar-menu ::v-deep .el-submenu .el-menu-item.is-active {
  background-color: rgba(64, 158, 255, 0.3) !important;
  color: #fff !important;
  font-weight: 600;
}

/* ===== 子菜单标题 ===== */
.sidebar-menu ::v-deep .el-submenu__title {
  margin: 2px 8px;
  border-radius: 4px;
  height: 46px;
  line-height: 46px;
  font-size: 14px;
  color: #bfcbd9 !important;
  transition: all 0.25s ease;
}

.sidebar-menu ::v-deep .el-submenu__title:hover {
  background-color: rgba(255, 255, 255, 0.05) !important;
  color: #fff !important;
}

.sidebar-menu ::v-deep .el-submenu.is-opened .el-submenu__title {
  color: #fff !important;
  font-weight: 600;
}

/* ===== 折叠状态 ===== */
.sidebar.collapsed .sidebar-menu ::v-deep .el-menu-item {
  padding-left: 22px !important;
  margin: 2px 6px;
  border-radius: 4px;
  justify-content: center;
}

.sidebar.collapsed .sidebar-menu ::v-deep .el-menu-item span {
  max-width: 0;
  opacity: 0;
  margin-left: 0;
}

.sidebar.collapsed .sidebar-menu ::v-deep .el-menu-item i {
  margin-right: 0;
}

.sidebar.collapsed .sidebar-menu ::v-deep .el-submenu__title {
  margin: 2px 6px;
  padding-left: 22px !important;
  justify-content: center;
}

.sidebar.collapsed .sidebar-menu ::v-deep .el-submenu__title i {
  margin-right: 0;
}

.sidebar.collapsed .sidebar-menu ::v-deep .el-submenu .el-menu-item {
  padding-left: 22px !important;
  margin: 2px 6px;
}

/* ========== Header ========== */
.header {
  background: #fff;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #303133;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  height: 60px;
  border-bottom: 1px solid #e6e6e6;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.header-title {
  font-size: 18px;
  font-weight: 700;
  color: #303133;
  display: flex;
  align-items: center;
  height: 100%;
}

/* ========== Hamburger Button ========== */
.hamburger-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  color: #606266;
  transition: all 0.25s ease;
}

.hamburger-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: #409EFF;
}

.header-title-icon {
  margin-right: 8px;
  color: #409EFF;
}

.header-right {
  display: flex;
  align-items: center;
  padding-right: 20px;
  gap: 8px;
}

/* ========== User Dropdown ========== */
.user-dropdown-link {
  color: #303133;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
}

/* ========== Main Content ========== */
.main-content {
  padding: 24px;
  background: #f0f2f5;
}

/* ========== Breadcrumb ========== */
.page-breadcrumb {
  margin: 0 0 20px 0;
  padding: 0;
  background-color: transparent;
  border-radius: 0;
  border: none;
  font-size: 14px;
}

.page-breadcrumb ::v-deep .el-breadcrumb__inner {
  color: #606266;
  font-weight: 500;
  transition: color 0.3s;
}

.page-breadcrumb ::v-deep .el-breadcrumb__inner.is-link:hover {
  color: #409EFF;
}

.page-breadcrumb ::v-deep .el-breadcrumb__separator {
  color: #c0c4cc;
  margin: 0 8px;
}

.page-breadcrumb ::v-deep .el-icon-s-home {
  margin-right: 2px;
}

/* ---- 禁用 animate.css 动画 ---- */
.main-layout-wrapper [class*="animate__"] {
  animation-duration: 0s !important;
  animation-delay: 0s !important;
  transition: none !important;
}

.sidebar-icp {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  padding: 14px 8px;
  font-size: 11px;
  color: #909399;
  letter-spacing: 0.5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  z-index: 1;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  background: #2b3a4a;
}

/* 滚动条 */
.sidebar::-webkit-scrollbar {
  width: 3px;
}
.sidebar::-webkit-scrollbar-track {
  background: transparent;
}
.sidebar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 3px;
}
.sidebar::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.25);
}

/* ========== Responsive ========== */
@media (max-width: 768px) {
  .sidebar {
    width: 64px !important;
  }

  .el-aside {
    width: auto !important;
  }
}
</style>

<style>
/* ========================================================================
   SIMPLE CLEAN STYLES — 朴素简洁
   所有样式仅作用于 .main-layout-wrapper 内部
   ======================================================================== */

/* ---- 按钮基础 ---- */
.main-layout-wrapper .el-button {
  border-radius: 4px;
  font-weight: 500;
  font-size: 14px;
}

.main-layout-wrapper .el-button--mini {
  border-radius: 3px;
  padding: 5px 12px;
  font-size: 12px;
}

.main-layout-wrapper .el-button--small {
  font-size: 13px;
}

/* ========================================================================
   RESPONSIVE LAYOUT — 搜索框 & 按钮区域响应式优化
   覆盖范围: 所有 MainLayout 子组件中的 el-row/el-col 布局
   断点: ≥1920 / 1200-1919 / 992-1199 / 768-991 / 480-767 / <480
   策略: flex-wrap + column-direction 在小屏
   ======================================================================== */

/* 超大屏 ≥1920: 保证最大宽度不溢出 */
@media (min-width: 1920px) {
  .main-layout-wrapper .main-content {
    max-width: 100%;
  }

  .main-layout-wrapper .el-card {
    max-width: 100%;
  }
}

/* 大屏 1200-1919: 保持多列但缩小间距 */
@media (min-width: 1200px) and (max-width: 1919px) {
  .main-layout-wrapper .el-row {
    flex-wrap: wrap;
  }
}

/* 中屏 992-1199: 搜索框列可以折行 */
@media (min-width: 992px) and (max-width: 1199px) {

  .main-layout-wrapper .el-col[class*="el-col-18"],
  .main-layout-wrapper .el-col[class*="el-col-22"] {
    width: 100%;
    margin-bottom: 10px;
  }

  .main-layout-wrapper .el-col[class*="el-col-6"][style*="text-align: right"],
  .main-layout-wrapper .el-col[class*="el-col-6"]:last-child {
    width: 100%;
    text-align: left !important;
    margin-bottom: 0;
  }

  .main-layout-wrapper .query-form-container .el-col[class*="el-col-7"],
  .main-layout-wrapper .query-form-container .el-col[class*="el-col-8"],
  .main-layout-wrapper .query-form-container .el-col[class*="el-col-6"] {
    width: 50%;
    margin-bottom: 10px;
  }

  .main-layout-wrapper .query-form-container .el-col:last-child {
    width: 100%;
    margin-bottom: 0;
  }

  .main-layout-wrapper .search-bar {
    flex-direction: column;
    align-items: stretch !important;
  }

  .main-layout-wrapper .search-bar>* {
    width: 100% !important;
  }

  .main-layout-wrapper .search-bar>div[style*="margin-left: auto"] {
    margin-left: 0 !important;
  }
}

/* 小平板 768-991: 所有列变为全宽堆叠 */
@media (min-width: 768px) and (max-width: 991px) {
  .main-layout-wrapper .el-row>.el-col {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
    margin-bottom: 10px;
    text-align: left !important;
  }

  .main-layout-wrapper .el-row>.el-col:last-child {
    margin-bottom: 0;
  }

  .main-layout-wrapper .filter-card [style*="display: flex"] {
    flex-wrap: wrap;
  }

  .main-layout-wrapper .filter-card .el-input,
  .main-layout-wrapper .filter-card .el-select,
  .main-layout-wrapper .filter-card .el-date-picker {
    width: 100% !important;
    max-width: 100% !important;
    margin-bottom: 8px;
  }

  .main-layout-wrapper .button-group {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .main-layout-wrapper .search-bar {
    flex-direction: column;
    align-items: stretch !important;
  }

  .main-layout-wrapper .search-bar>* {
    width: 100% !important;
  }

  .main-layout-wrapper .search-bar>div[style*="margin-left: auto"] {
    margin-left: 0 !important;
  }

  .main-layout-wrapper .query-form-container .el-row>.el-col {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
  }

  .main-layout-wrapper .query-form-container .el-form-item {
    width: 100% !important;
  }
}

/* 手机横屏 480-767 */
@media (min-width: 480px) and (max-width: 767px) {
  .main-layout-wrapper .el-row>.el-col {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
    margin-bottom: 10px;
    text-align: left !important;
  }

  .main-layout-wrapper .filter-card [style*="display: flex"] {
    flex-direction: column;
  }

  .main-layout-wrapper .filter-card .el-input,
  .main-layout-wrapper .filter-card .el-select,
  .main-layout-wrapper .filter-card .el-date-picker {
    width: 100% !important;
    max-width: 100% !important;
    margin-bottom: 8px;
    margin-right: 0 !important;
  }

  .main-layout-wrapper .el-form--inline .el-form-item {
    display: block;
    margin-right: 0;
    margin-bottom: 10px;
  }

  .main-layout-wrapper .button-group {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-left: 0 !important;
  }

  .main-layout-wrapper .search-bar {
    flex-direction: column;
    align-items: stretch !important;
  }

  .main-layout-wrapper .search-bar>* {
    width: 100% !important;
  }

  .main-layout-wrapper .search-bar>div[style*="margin-left: auto"] {
    margin-left: 0 !important;
  }

  .main-layout-wrapper .query-form-container .el-col {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
  }
}

/* 小手机 <480 */
@media (max-width: 479px) {
  .main-layout-wrapper .el-row>.el-col {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
    margin-bottom: 8px;
    text-align: left !important;
  }

  .main-layout-wrapper .filter-card [style*="display: flex"] {
    flex-direction: column;
  }

  .main-layout-wrapper .filter-card .el-input,
  .main-layout-wrapper .filter-card .el-select,
  .main-layout-wrapper .filter-card .el-date-picker {
    width: 100% !important;
    max-width: 100% !important;
    margin-bottom: 8px;
    margin-right: 0 !important;
  }

  .main-layout-wrapper .el-form--inline .el-form-item {
    display: block;
    margin-right: 0;
    margin-bottom: 8px;
  }

  .main-layout-wrapper .el-button+.el-button {
    margin-left: 0;
    margin-top: 6px;
  }

  .main-layout-wrapper .button-group {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-left: 0 !important;
  }

  .main-layout-wrapper .el-header {
    padding: 0 10px !important;
  }

  .main-layout-wrapper .header-title {
    padding-left: 10px;
    font-size: 14px;
  }

  .main-layout-wrapper .header-right {
    padding-right: 10px;
  }

  .main-layout-wrapper .el-main {
    padding: 10px !important;
  }

  .main-layout-wrapper .search-bar {
    flex-direction: column;
    align-items: stretch !important;
    gap: 8px;
  }

  .main-layout-wrapper .search-bar>* {
    width: 100% !important;
  }

  .main-layout-wrapper .search-bar>div[style*="margin-left: auto"] {
    margin-left: 0 !important;
    flex-direction: column;
  }

  .main-layout-wrapper .query-form-container .el-col {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
  }

  .main-layout-wrapper .pagination-container {
    overflow-x: auto;
  }
}

/* ---- 卡片样式 ---- */
.main-layout-wrapper .el-card {
  border-radius: 4px;
  border: 1px solid #ebeef5;
}

.main-layout-wrapper .filter-card {
  border-radius: 4px !important;
  border: 1px solid #ebeef5 !important;
  box-shadow: none !important;
}

/* ---- 表格头 ---- */
.main-layout-wrapper .el-table th,
.main-layout-wrapper .el-table th.is-leaf {
  background: #f5f7fa;
  color: #303133;
  font-weight: 600;
  font-size: 13px;
  border-bottom: 1px solid #ebeef5;
}

.main-layout-wrapper .el-table {
  table-layout: fixed;
}

.main-layout-wrapper .el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: #fafafa;
}

.main-layout-wrapper .el-table__body tr:hover>td {
  background-color: #f5f7fa;
}

.main-layout-wrapper .el-table td,
.main-layout-wrapper .el-table th.is-leaf {
  border-right: none;
}

.main-layout-wrapper .el-table--border::after,
.main-layout-wrapper .el-table--group::after,
.main-layout-wrapper .el-table::before {
  background-color: transparent;
}

/* ---- Focus 焦点样式 ---- */
.main-layout-wrapper .el-input__inner:focus {
  border-color: #409EFF !important;
}

.main-layout-wrapper .el-select .el-input.is-focus .el-input__inner {
  border-color: #409EFF !important;
}

.main-layout-wrapper .el-textarea__inner:focus {
  border-color: #409EFF !important;
}

/* ---- 分页 ---- */
.main-layout-wrapper .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #409EFF !important;
  color: #fff !important;
}

.main-layout-wrapper .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #409EFF !important;
}

/* ---- 复选框/单选框 ---- */
.main-layout-wrapper .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #409EFF !important;
  border-color: #409EFF !important;
}

.main-layout-wrapper .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #409EFF !important;
}

.main-layout-wrapper .el-radio__input.is-checked .el-radio__inner {
  background-color: #409EFF !important;
  border-color: #409EFF !important;
}

.main-layout-wrapper .el-radio__input.is-checked+.el-radio__label {
  color: #409EFF !important;
}

.main-layout-wrapper .el-switch.is-checked .el-switch__core {
  background-color: #409EFF !important;
  border-color: #409EFF !important;
}

/* ---- Tabs ---- */
.main-layout-wrapper .el-tabs__active-bar {
  background-color: #409EFF !important;
}

.main-layout-wrapper .el-tabs__item.is-active {
  color: #409EFF !important;
  font-weight: 600;
}

.main-layout-wrapper .el-tabs__item:hover {
  color: #409EFF !important;
}

.main-layout-wrapper .el-pager li.active {
  color: #409EFF !important;
}

/* ---- 链接 ---- */
.main-layout-wrapper a {
  color: #409EFF;
  font-weight: 500;
}

.main-layout-wrapper a:hover {
  color: #66b1ff;
}

/* ---- ZOOM SCALE FIX ---- */
.main-layout-wrapper .filter-card .el-input,
.main-layout-wrapper .filter-card .el-select {
  min-width: 120px;
}

.main-layout-wrapper .filter-card .el-date-picker,
.main-layout-wrapper .filter-card .el-date-editor {
  min-width: 180px;
}

.main-layout-wrapper .query-form-container .el-date-editor {
  min-width: 220px;
}

.main-layout-wrapper .button-group {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
}

.main-layout-wrapper .button-group .el-button {
  white-space: nowrap;
}

/* ---- responsive table horizontal scroll on small screens ---- */
@media (max-width: 991px) {
  .main-layout-wrapper .el-table {
    display: block;
    overflow-x: auto;
  }
}

.main-layout-wrapper .filter-card {
  margin-bottom: 16px;
}

.main-layout-wrapper .filter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.main-layout-wrapper .filter-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.main-layout-wrapper .action-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.main-layout-wrapper .filter-select {
  width: 160px;
}

.main-layout-wrapper .filter-select-sm {
  width: 130px;
}

.main-layout-wrapper .filter-input {
  width: 180px;
}

.main-layout-wrapper .filter-input-id {
  width: 120px;
}

.main-layout-wrapper .filter-date {
  width: auto;
  min-width: 280px;
}

/* ---- responsive filter-bar (Goods Management) ---- */
@media (max-width: 767px) {
  .main-layout-wrapper .filter-bar {
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 10px;
  }

  .main-layout-wrapper .filter-bar .filter-group,
  .main-layout-wrapper .filter-bar .action-group {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
  }

  .main-layout-wrapper .filter-bar .filter-select,
  .main-layout-wrapper .filter-bar .filter-select-sm,
  .main-layout-wrapper .filter-bar .filter-input,
  .main-layout-wrapper .filter-bar .filter-input-id,
  .main-layout-wrapper .filter-bar .filter-date {
    width: 100% !important;
    max-width: 100% !important;
  }

  .main-layout-wrapper .filter-bar .action-group {
    margin-left: 0 !important;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .main-layout-wrapper .filter-bar {
    flex-wrap: wrap;
    gap: 10px;
  }

  .main-layout-wrapper .filter-bar .filter-group {
    flex-wrap: wrap;
    gap: 6px;
    width: 100%;
  }

  .main-layout-wrapper .filter-bar .action-group {
    width: 100%;
    margin-left: 0 !important;
  }
}

/* ---- table horizontal scroll on narrow screens ---- */
@media (max-width: 1200px) {
  .main-layout-wrapper .el-table__body-wrapper {
    overflow-x: auto;
  }
}

/* ---- date picker responsive ---- */
@media (max-width: 767px) {
  .main-layout-wrapper .filter-date {
    width: 100% !important;
    max-width: 100% !important;
  }

  .main-layout-wrapper .el-date-editor.el-range-editor {
    width: 100% !important;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .main-layout-wrapper .filter-bar {
    flex-wrap: wrap;
    gap: 10px;
  }

  .main-layout-wrapper .filter-bar .filter-group {
    flex-wrap: wrap;
    gap: 6px;
  }
}

/* ---- responsive dialog on small screens ---- */
@media (max-width: 767px) {
  .main-layout-wrapper .el-dialog {
    width: 90% !important;
    max-width: 90vw !important;
    margin: 0 auto !important;
  }

  .main-layout-wrapper .el-dialog__body {
    padding: 15px !important;
  }

  .main-layout-wrapper .el-dialog__header {
    padding: 15px 15px 10px !important;
  }

  .main-layout-wrapper .el-dialog__footer {
    padding: 10px 15px 15px !important;
  }

  .main-layout-wrapper .el-form-item__label {
    width: auto !important;
    min-width: 70px;
  }

  /* date picker full width */
  .main-layout-wrapper .el-date-editor.el-range-editor {
    width: 100% !important;
    max-width: 100% !important;
  }

  /* small form-inline items stack */
  .main-layout-wrapper .el-form--inline .el-form-item__content {
    width: 100% !important;
  }

  .main-layout-wrapper .el-form--inline .el-input,
  .main-layout-wrapper .el-form--inline .el-select {
    width: 100% !important;
  }
}

/* ---- summary cards: 3 per row on tablets (992-1199), 2 per row on mobile ---- */
@media (min-width: 992px) and (max-width: 1199px) {
  .main-layout-wrapper .summary-cards .summary-card {
    flex: 0 1 calc(33.33% - 8px) !important;
    min-width: 200px;
  }
}

@media (max-width: 767px) {
  .main-layout-wrapper .summary-cards .summary-card {
    flex: 0 1 calc(50% - 6px) !important;
    min-width: 140px;
  }
}

/* ---- pagination: simplify on small screens ---- */
@media (max-width: 600px) {
  .main-layout-wrapper .el-pagination .el-pagination__sizes {
    display: none !important;
  }

  .main-layout-wrapper .el-pagination .el-pagination__jump {
    display: none !important;
  }

  .main-layout-wrapper .el-pagination button,
  .main-layout-wrapper .el-pagination .el-pager li {
    min-width: 28px;
    height: 28px;
    line-height: 28px;
  }

  .main-layout-wrapper .pagination-container {
    justify-content: center !important;
  }
}

/* ---- descriptions: single column on mobile ---- */
@media (max-width: 767px) {
  .main-layout-wrapper .el-descriptions .el-descriptions__body .el-descriptions__table.is-bordered {
    display: block;
  }

  .main-layout-wrapper .el-descriptions .el-descriptions__body .el-descriptions__table .el-descriptions__cell {
    display: block;
  }
}

/* ========================================================================
   TABLE PERFORMANCE: paint containment + fixed layout
   ======================================================================== */
.main-layout-wrapper .page-container {
  contain: layout style paint;
}

.main-layout-wrapper .el-table .el-table__body-wrapper {
  will-change: transform;
}
</style>
